import * as metroMapUtils from '../../utilities/metromap';
import { mpConstants } from '../constants/mp';

import _ from 'lodash/fp';

export const loadHighResLayersMp =
  (collectionIds, bbox, currentDate = null) =>
  async (dispatch) => {
    dispatch({ type: mpConstants.LOAD_HIGH_RES_LAYERS });
    try {
      const layersArr = (
        await Promise.all(
          collectionIds.map(
            // see https://advancedweb.hu/how-to-use-async-functions-with-array-map-in-javascript/ for how this works
            async (collectionId) =>
              (await metroMapUtils.getHighResLayers(collectionId, bbox)) || []
          )
        )
      ).flat();
      const layers = metroMapUtils.groupHighResLayersByDate(layersArr);
      dispatch({
        type: mpConstants.LOAD_HIGH_RES_LAYERS_SUCCESS,
        payload: layers,
      });

      const dates = _.keys(layers);
      if (dates.length > 0) {
        let dateToSet = null;

        // If currentDate is provided and exists in layers, use it
        if (currentDate && _.has(currentDate, layers)) {
          dateToSet = currentDate;
        } else {
          // Otherwise use the latest date (first in the sorted list)
          dateToSet = dates[0];
        }

        // Always dispatch date change to ensure UI updates
        dispatch({
          type: mpConstants.SET_HIGH_RES_CURRENT_DATE,
          payload: dateToSet,
        });
      } else {
        // If no dates available, clear current date
        dispatch({
          type: mpConstants.SET_HIGH_RES_CURRENT_DATE,
          payload: null,
        });
      }
    } catch (error) {
      console.error(error);
      dispatch({
        type: mpConstants.LOAD_HIGH_RES_LAYERS_FAILURE,
        payload: 'something went wrong',
      });
      // Clear current date on error
      dispatch({
        type: mpConstants.SET_HIGH_RES_CURRENT_DATE,
        payload: null,
      });
    }
  };

export const loadHighResCollectionsMp = () => async (dispatch) => {
  dispatch({ type: mpConstants.LOAD_HIGH_RES_COLLECTIONS });
  try {
    const collections = await metroMapUtils.getHighResCollections();
    dispatch({
      type: mpConstants.LOAD_HIGH_RES_COLLECTIONS_SUCCESS,
      payload: collections,
    });
  } catch (error) {
    console.error(error);
    dispatch({
      type: mpConstants.LOAD_HIGH_RES_COLLECTIONS_FAILURE,
      payload: 'something went wrong',
    });
  }
};

export const nextHighResLayerMp = () => (dispatch) => {
  dispatch({
    type: mpConstants.NEXT_HIGH_RES_LAYER,
  });
};

export const prevHighResLayerMp = () => (dispatch) => {
  dispatch({
    type: mpConstants.PREV_HIGH_RES_LAYER,
  });
};
